import { LAYOUT_OPTIONS } from "@/config/enums";
import { useIsMounted } from "@/hooks/use-is-mounted";
import BerylLiumLayout from "@/layouts/beryllium/beryllium-layout";
import BoronLayout from "@/layouts/boron/boron-layout";
import CarbonLayout from "@/layouts/carbon/carbon-layout";
import HeliumLayout from "@/layouts/helium/helium-layout";
import HydrogenLayout from "@/layouts/hydrogen/layout";
import LithiumLayout from "@/layouts/lithium/lithium-layout";
import { useLayout } from "@/layouts/use-layout";

export default function DefaultLayout() {
  return <LayoutProvider />;
}

function LayoutProvider() {
  const { layout } = useLayout();
  const isMounted = useIsMounted();

  if (!isMounted) {
    return null;
  }

  if (layout === LAYOUT_OPTIONS.HELIUM) {
    return <HeliumLayout />;
  }
  if (layout === LAYOUT_OPTIONS.LITHIUM) {
    return <LithiumLayout />;
  }
  if (layout === LAYOUT_OPTIONS.BERYLLIUM) {
    return <BerylLiumLayout />;
  }
  if (layout === LAYOUT_OPTIONS.BORON) {
    return <BoronLayout />;
  }
  if (layout === LAYOUT_OPTIONS.CARBON) {
    return <CarbonLayout />;
  }

  return <HydrogenLayout />;
}
